<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
<div style="margin:2rem 2rem 10rem 2rem; padding:2rem 2rem;">
    <h1>{{CNF('app.name')}}</h1>
    <div style="margin: 10px 20px;text-align:left;">
      <div>插件组件路由格式：/plugin/&lt;PluginName&gt;/&lt;Controller&gt;/&lt;Action&gt;，
        即以 /plugin/ 开头的路径等同于 plugin://&lt;PluginName&gt;/&lt;Controller&gt;/&lt;Action&gt;，
        将路由到插件内部组件。</div>
      <br/>
      跳转测试：<el-input v-model="toUrl" placeholder="请输入跳转地址" style="width: 500px;"></el-input>
      &nbsp;<el-button type="primary" @click="jumpTo">跳转</el-button>
      
      <pre style="text-align: left;">
代码示例：
click: function() {
  this.$router.push({
    path: this.toUrl,
    query: {
      abc: 1,
      bcd: 2
    }
  });
}
      </pre>
    </div>
    <hr/>
    <div style="margin: 10px 20px;text-align:left;">
      动态加载：<el-input v-model="dyJs" placeholder="请输入地址" style="width: 500px;"></el-input>
      &nbsp;<el-button type="primary" @click="loadJs">动态加载</el-button>
      <div>{{dyJsMsg}}</div>
    </div>
    <hr/>
    <div style="margin: 10px 20px;text-align:left;">
      传递进来的 props 值：
      <ul style="text-align: left;">
        <li>fullPath: {{fullPath}}</li>
        <li>path: {{path}}</li>
        <li>query: <pre>{{JSON.stringify(query, null, 4)}}</pre></li>
        <li>hash: {{hash}}</li>
        <li>targetUrl: <pre>{{targetUrl}}</pre></li>
        <li>targetUri: <pre>{{JSON.stringify(targetUri, null, 4)}}</pre></li>
        <li>menu: <pre>{{JSON.stringify(menu, null, 4)}}</pre></li>
      </ul>
    </div>
</div>
    </div>
  </zj-layout-main>
</zj-layout-container>
  
</template>

<script>

import ZJApp from '../../../../app'

export default {
  name: 'ZjDemoHome',
  controller: 'UI',
  action: 'Home',
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object
  },
  data() {
    return {
      toUrl: '/plugin/emergency/ui/home',
      dyJs: '/lib/Script/jquery.js',
      dyJsMsg: ''
    };
  },
  methods: {
    jumpTo() {
      
      this.$router.push({
        path: this.toUrl,
        query: {
          abc: 1,
          bcd: 2
        }
      });
    },
    loadJs() {
      const utils = ZJApp.ZJUtils;
      utils.loadScript(this.dyJs)
        .then(()=>this.dyJsMsg = '加载成功')
        .catch(()=>this.dyJsMsg = '加载失败');

      //按序加载
      utils.waitAll([
        ()=>utils.loadScript('/dfdf/dfd.js'),
        ()=>utils.loadScript('/dfdf/dfd2.js'),
        ()=>utils.loadScript('/dfdf/dfd3.js')
      ])
        .then(()=>this.dyJsMsg = '加载成功')
        .catch(()=>this.dyJsMsg = '加载失败');
      
    }
  }
}
</script>
